export default __webpack_public_path__ + "static/media/widget-blank-dashboard.af44f0cd.png";